/**
 * 說明 : 梯控申請資料與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import { createAsyncThunk } from "@reduxjs/toolkit";

// ----- import from Base API -----
import BaseAPI from "./BaseAPI";

// 新增梯控申請
export const addApply = createAsyncThunk(
    "apply/addApply",
    async (applDetail, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/elevMgmt/apply", applDetail, token);
            return data;
        } catch (err) {
            console.error('add apply error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改梯控申請
export const editApply = createAsyncThunk(
    "apply/editApply",
    async (applDetail, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/elevMgmt/apply", applDetail, token);
            return data;
        } catch (err) {
            console.error('edit apply error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改梯控申請狀態
export const editApplyStatus = createAsyncThunk(
    "apply/editApplyStatus",
    async ({applDetailIds, status }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/elevMgmt/apply/status", {applDetailIds: applDetailIds, flgStatus: status }, token);
            return data;
        } catch (err) {
            console.error('edit apply status error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 重設密碼
export const resetPassword = createAsyncThunk(
    "apply/resetPassword",
    async ({ applicantId }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth(`/elevMgmt/apply/resetPassword`, {applicantId: applicantId}, token);
            return data;
        } catch (err) {
            console.error('reset password error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得單筆梯控申請資料
export const fetchApply = createAsyncThunk(
    "apply/fetchApply",
    async (applDetailId, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth(`/elevMgmt/apply/${applDetailId}`, token);
            return data;
        } catch (err) {
            console.error('fetch apply error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得梯控申請清單列表
export const fetchApplyList = createAsyncThunk(
    "apply/fetchApplyList",
    async ({ buildingId, elevatorId, applicantName, applicantType }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/elevMgmt/apply", { buildingId: buildingId, elevatorId: elevatorId, applicantName: applicantName, applicantType: applicantType }, token);
            return data;
        } catch (err) {
            console.error('fetch apply list error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 匯入梯控申請者資料
export const importApply = createAsyncThunk(
    "apply/importApply",
    async ({ applicants }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/elevMgmt/apply/import", { applicants: applicants }, token);
            return data;
        } catch (err) {
            console.error('import apply error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 重設手機驗證碼
export const resetVenderId = createAsyncThunk(
    "apply/resetVenderId",
    async ({ applicantId }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth(`/elevMgmt/apply/resetVenderId`, {applicantId: applicantId}, token);
            return data;
        } catch (err) {
            console.error('reset venderId error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);
